import React, { useEffect, useState } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc, serverTimestamp, arrayRemove } from "firebase/firestore"
import {  Link, useNavigate, useParams } from "react-router-dom"
import { db, storage } from '../../../firebase'
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
// import { useTheme } from '@mui/material/styled';
import { useTheme } from '@material-ui/core/styles';
import { allRegions, allAreas, allOutlets, openList } from '../../../data/dataSource'
import { deleteObject, ref } from 'firebase/storage'



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      // width: 250,
    },
  },
};




const outletAmenities = [
    {key:'1', value:'Free Wifi'},
    {key:'2', value:'Car Wash'},
    {key:'3', value:'Swimming Pool'},
    {key:'4', value:'Pool Bar',},
    {key:'5', value:'Live Music'},
    {key:'6', value:'Parking Space'},
    {key:'7', value:'Smart TVs'},
    {key:'8', value:'Secured Environment'},
    {key:'9', value:'Gym/Fitness Centre'},
    {key:'10', value:'Laundry Services'},
    {key:'11', value:'Complimentary Breakfast'},
    {key:'12', value:'Spa/Wellness Services'},
    {key:'13', value:'Airport Pick-up'},
    {key:'14', value:'VIP Space'},
    {key:'15', value:'Enhance Hygiene'},
    {key:'16', value:'Cozy Serenity'},
    {key:'17', value:'Board & Outdoor Games'},
    {key:'18', value:'Meeting & Event Spaces',},
    {key:'19', value:'Smart Rooms'},
    {key:'20', value:'Pet Friendly'},
    {key:'21', value:'Virtual Reality Experience'},
    {key:'22', value:'Beauty treatment & Salon services'},
    {key:'23', value:'Private Security & Escort Services'},
    {key:'24', value:'Movie Theatre'},
    {key:'25', value:'Private Masseurs'},
    {key:'26', value:'Adventure Park'},
    {key:'27', value:'Boutique',},
    {key:'28', value:'Mini sport court'},
    {key:'29', value:'Outdoor Patio'},
    {key:'30', value:'Work Station'},

]




const Edit = ({user}) => {

  const {outletId} = useParams()


  const [ outletData, setOutletData ] = useState([])


  const [ region, setRegion ] = useState("")

  const [ area, setArea ] = useState("")
  
  const [ category, setCategory ] = useState("")

  const [outletname, setOutletname] = useState("")

  const [address, setAddress] = useState("")

  const [amenities, setAmenities] = useState([]);

  const [description, setDescription] = useState("")

  const [open, setOpen ] = useState("")

  const [telephone, setTelephone] = useState("")

  const [whatsapp, setWhatsapp] = useState("")

  const [subscriberID, setSubscriberID] = useState("")

  const [ agentCode, setAgentCode] = useState("")

  const [ review, setReview] = useState([])

  const [photos, setPhotos] = useState([])
 
  const [ openModal, setOpenModal ] = useState(false)

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)

  const [isloading, setIsloading] = useState(false)

  const [areaList, setAreaList] = useState([])

  const [categoryList, setCategoryList] = useState([])

  const [searchList, setSearchList] = useState([])

  const [resetKeyRegion, setResetKeyRegion] = useState(0);

  const [resetKeyArea, setResetKeyArea] = useState(0);

  const [resetKeyCategory, setResetKeyCategory] = useState(0);

  const [counter, setCounter] = useState(0);

  const [filesLength, setFilesLength] = useState(0)

  const theme = useTheme();

  const [errorCategory, setErrorCategory] = useState("")

  const [errorOutletname, setErrorOutletname] = useState("")

  const [errorAddress, setErrorAddress] = useState("")

  const [errorRegion, setErrorRegion] = useState("")

  const [errorArea, setErrorArea] = useState("")

  const [errorAmenity, setErrorAmenity] = useState("")

  const [errorDescription, setErrorDescription] = useState("")

  const [errorOpen, setErrorOpen] = useState("")

  const [errorTelephone, setErrorTelephone] = useState("")

  const [errorWhatsapp, setErrorWhatsapp] = useState("")

  
function getStyles(amenity, amenities, useTheme) {
  return {
    fontWeight: amenity.includes(amenity)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}


const navigate = useNavigate()

  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };

  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }

    const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setAmenities(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };


    const decrementCounter = () => {
        setCounter(counter - 1);
    };

     const deleteUrl = async(i) => {

        
            const deleteRef = ref(storage, i);
    
            deleteObject(deleteRef).then(async() => {
           
                const photoRef = doc(db, "subscribers", outletId);
    
                await updateDoc(photoRef, {

                    files: arrayRemove(i)
                });
    
                decrementCounter()
        
                
                alert("Photo removed")
        
        
            }).catch((error) => {

                console.log(error)

            });
        
    }
    
    
 useEffect(() => {

     if(region){

        setAreaList(allAreas[region] || []);
    
     } else {

        setAreaList([]);

        setArea(null)

    }


 }, [region])

 


  useEffect(() => {

    
     if(area){

      setCategoryList(allOutlets[area] || []);

     }else {
     
      setCategoryList([]);

      setCategory(null);
    }


 }, [area])


  // const handleChangecategory = (event) => {

  //   setCategory(event.target.value);
  
  // };

   const handleChangeRegion = (event) => {

     setRegion(event.target.value);

      setArea("");

      setCategory("");


      setResetKeyArea(prevKey => prevKey + 1);

      setResetKeyCategory(prevKey => prevKey + 1);
      // setOutletList([]);

      if (event.target.value) {


        setAreaList(allAreas[event.target.value] || []);

      } else {

        setAreaList([]);

      }


      // setAreaList(allAreas[region] || []);

  
  };




  const handleChangeArea = (event) => {

      setArea(event.target.value);

      setCategory("");


      setResetKeyCategory(prevKey => prevKey + 1);
      // setOutletList([]);

      if (event.target.value) {


        setCategoryList(allOutlets[event.target.value] || []);

      } else {

        setCategoryList([]);

      }

  } 



   const handleChangecategory = (event) => {

      setCategory(event.target.value);      
  
  } 

 
  

  
  const getOutlet = async() => {

      const docRef = doc(db, "subscribers", outletId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setOutletData(docSnap.data())
        setCategory(docSnap.data().outlet)
        setRegion(docSnap.data().region)
        setArea(docSnap.data().area)
        setOutletname(docSnap.data().outletname)
        setAddress(docSnap.data().address)
        setAmenities(docSnap.data().amenity)
        setDescription(docSnap.data().description)
        setOpen(docSnap.data().open)
        setSubscriberID(docSnap.data().subscriberID)
        setTelephone(docSnap.data().telephone)
        setWhatsapp(docSnap.data().whatsapp)
        setAgentCode(docSnap.data().agentCode)
        setFilesLength(docSnap.data().files.length)
        setCounter(docSnap.data().counter)
        // console.log(outletData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }



  useEffect(()=>{

    getOutlet()

  }, [])



   useEffect(() => {
    
        const unsub = onSnapshot(doc(db, "subscribers", outletId), (doc) => {
    
            
            setPhotos(doc.data().files)
            
    
        });
    
        return () => unsub()
    
    
    
    }, [photos])






  //  useEffect(() => {
    
  //   //LISTEN REAL TIME

  //   const reviewQuery = async() => {

  //     const reviewRef = (collection(db, "reviews"));
  //     const q = query(reviewRef, where("subId", "==", outletId));

  //     const querySnapshot = await getDocs(q);
  //       let list = []
  //     querySnapshot.forEach((doc) => {
  //       // doc.data() is never undefined for query doc snapshots
  //       list.push(doc.data())
  //       // console.log(doc.id, " => ", doc.data());
  //       console.log(list)

  //       setReview(list)
  //       // console.log(orderData)
  //     });

  //   }
    
  //   reviewQuery()   

  // },[])





// const handleModal = (photo) => {

//   setOpenModal(true) 
//   setPhotos(photo)

// }


  // const options = {  maximumFractionDigits: 2 }


//   const Modal = ({open, close, photo}) => {
     
//     if(!open) return null
//     return(
//      <div style={{
//       backgroundColor: 'black',
//       widows:'100%',
//       height:'100%',
//      }}>
//        <div style={{

//         maxWidth: 600,
//         backgroundColor: 'white',
//       }}>
       
//          <div className="modalRight">
//            <p className="closeBtn" onClick={close}>X</p>
//            <div></div>

 
//          </div>
//        </div>
//      </div>
//     )
// }


     const handleStatus = async() => {
    
        
        const outletRef = doc(db, "subscribers", outletId);
    
        await updateDoc(outletRef, {
    
        status: outletData.status === "active" ? 'inactive' : 'active', 
    
     })
    
      setOpenStatus(false)
    
      }



      const handleUpdateOutlet = async() => {

        if (category === "") {
            return setErrorCategory("This field is important")
            
        }

        if (amenities === "") {
            return setErrorAmenity("This field is important")
            
        }

        if (outletname === "") {
            return setErrorOutletname("This field is important")
            
        }

        if (region === "") {
            return setErrorRegion("This field is important")
            
        }

        if (area === "") {
            return setErrorArea("This field is important")
            
        }

        if (address === "") {
            return setErrorAddress("This field is important")
            
        }

        if (open === "") {
            return setErrorOpen("This field is important")
            
        }

        if (description === "") {
            return setErrorDescription("This field is important")
            
        }

        if (telephone === "") {
            return setErrorTelephone("This field is important")
            
        }

        if (whatsapp === "") {
            return setErrorWhatsapp("This field is important")
            
        }

        setIsloading(true)

        try {
    
            // const docRef = await addDoc(collection(db, "subscribers"), {
            await updateDoc(doc(db, "subscribers", outletId), {
    
              outlet : category,
    
              amenity : amenities,
    
              outletname : outletname,
    
              region : region,
    
              area : area,

              address : address,
    
              open : open,
    
              description : description,
    
              telephone : telephone,

              whatsapp : whatsapp,

              agentCode : agentCode,
    
              subscriberID : subscriberID, 

              // status : status,

              // files : files,

              // amount : amount,  

              timeStamp: serverTimestamp(),
    
            })


           setIsloading(false)

           navigate('/outlets')

                     
        } catch (error) {
    
          console.log(error.message);

          setIsloading(false)

        }
    
    
       
      }
 

  return (
    <div className='single'>
      {/* <Modal open={openModal} close={closeModal} /> */}
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between', paddingRight:50}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Edit  {outletData.outletname} {outletData.outlet}</h2>

              <div className='topRight'>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  href="/outlets"
                >
                  Outlet List
                </Link>
                <Typography color="green">Edit Outlet</Typography>
              </Breadcrumbs>
              </div>

            </div>

           



            {/* <div className='item'>
            <img
                src = {outletData.files}
                alt="avatar"
                style={{width:'200px', height:'200px', borderRadius:'50%'}}
                   
            /> 
              
                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Subscriber ID:</span>
                    <span className='itemValue'>{outletData.subscriberID}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Name:</span>
                    <span className='itemValue'>{outletData.outletname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet:</span>
                    <span className='itemValue'>{outletData.outlet}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Region:</span>
                    <span className='itemValue'>{outletData.region}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Area:</span>
                    <span className='itemValue'>{outletData.area}</span>
                  </div>
                </div>


                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{outletData.address_short}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Full Address:</span>
                    <span className='itemValue'>{outletData.address}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Telephone:</span>
                    <span className='itemValue'>{outletData.telephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Whatsapp Number:</span>
                    <span className='itemValue'>{outletData.whatsapp}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{outletData.date}</span>
                  </div>
                 
                </div>



                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Subscription Plan:</span>
                    <span className='itemValue'>{outletData.subscriberPlan}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Subscription Amount:</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Payment Reference:</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Open Hour:</span>
                    <span className='itemValue'>{outletData.open}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{outletData.date}</span>
                  </div>
                 
                </div>

              

            </div> */}
          </div>
       
        </div>
        <div className="top">
          <div className="left">
            {/* <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Subscriber(Owner) Details</h2> */}

              <div className='form'>
            
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
                 
                  <Box sx={{ minWidth: '47%' }} >
                    <FormControl fullWidth>
                    <InputLabel id="region" style={{color:'#999', fontWeight:300}}>Select An Outlet City</InputLabel>
                    <Select
                      labelId="region"
                      id="region"
                      value={region}
                      key={resetKeyRegion}
                      label="Region"
                      onChange={handleChangeRegion}
                      // onChange={(e) => setRegion(e.target.value)}
                    >
                      {allRegions.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            {item.value}
                          </MenuItem>

                        ) 
                      })} 

                    </Select>
                    </FormControl>
                  </Box>

                   {errorRegion &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorRegion}</p>
                   }

                   </div>

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                   <Box sx={{ minWidth: '47%' }} >
                    <FormControl fullWidth>
                    <InputLabel id="area" style={{color:'#999', fontWeight:300}}>Select An Outlet Area</InputLabel>
                    <Select
                      labelId="area"
                      id="area"
                      value={area}
                      key={resetKeyArea}
                      label="area"
                      onChange={handleChangeArea}
                      // onChange={change}
                   
                    >

                      {areaList.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            {item.value}
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>

                   {errorArea &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorArea}</p>
                   }

                   </div>



                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                    <Box sx={{ minWidth: '47%' }} >
                    <FormControl fullWidth>
                    <InputLabel id="category" style={{color:'#999', fontWeight:300,}}>Select A Category</InputLabel>
                    <Select
                      labelId="category"
                      id="category"
                      value={category}
                      key={resetKeyCategory}
                      label=""
                      onChange={handleChangecategory}                     
                    >

                      {categoryList.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>{item.value}</MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>
                   {errorCategory &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorCategory}</p>
                   }

                  </div>

                  

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                    <TextField
                    id="outletname"
                    onChange={(e) => setOutletname(e.target.value)}
                    value = {outletname}
                    placeholder="What is Your Outlet Name"
                    style={{width:'100%'}}


                  />

                  {errorOutletname &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorOutletname}</p>
                  }

                   </div>

                 
                

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                    <TextField
                    id="address"
                    onChange={(e) => setAddress(e.target.value)}
                    value = {address}
                    placeholder="Enter Your Outlet Address"
                    style={{width:'100%'}}

                  />

                   {errorAddress &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorAddress}</p>
                   }

                  </div>

                

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                     <FormControl sx={{ m: 1, width: '100%' }}>
                    <InputLabel id="amenity">Select Outlet Amenities</InputLabel>
                    <Select
                      labelId="amenity"
                      id="amenity-chip"
                      multiple
                      value={amenities}
                      onChange={handleChange}
                      input={<OutlinedInput id="amenity" label="Amenity" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {outletAmenities.map((item) => (
                        <MenuItem
                          key={item.key}
                          value={item.value}
                          style={getStyles(item.value, amenities, theme)}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                   {errorAmenity &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorAmenity}</p>
                   }

                   </div>

                 
                    

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
                    
                    <TextField
                    id="description" 
                    value={description}
                    multiline
                    minRows={3}
                    maxRows={10}
                    placeholder="Enter Message"
                    style={{width:'100%'}}
                    onChange={(e) => setDescription(e.target.value)}
                  />

                   {errorDescription &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorDescription}</p>
                   }
                    
                  </div> 

                


                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                   <Box sx={{ minWidth: '100%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="open" style={{color:'#999', fontWeight:300}}>Select Your Outlet Work Hour</InputLabel>
                    <Select
                      labelId="open"
                      id="open"
                      value={open}
                      label="open"
                      onChange={(e) => setOpen(e.target.value)}
                
                    >

                 

                    {openList.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', gap:40}}>
                                {item.value}
                                <div style={{width:20, height:20, backgroundColor:item.code}}></div>
                            </div>
                          </MenuItem>

                        ) 
                      })} 

                    </Select>
                    </FormControl>
                  </Box>

                    {errorOpen &&
                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorOpen}</p>
                    }

                   </div>
                  
                  

                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
                    <TextField
                    id="telephone"
                    onChange={(e) => setTelephone(e.target.value)}
                    value = {telephone}
                    placeholder="Enter Your Outlet Telephone"
                    style={{width:'100%'}}
                  />

                   {errorTelephone &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorTelephone}</p>
                   }

                    </div>

                

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                   
                  <TextField
                    id="whatsApp"
                    onChange={(e) => setWhatsapp(e.target.value)}
                    value = {whatsapp}
                    placeholder="Enter Your Outlet WhatsApp Number"
                    style={{width:'100%'}}

                  />

                   {errorWhatsapp &&
                   <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorWhatsapp}</p>
                   }

                   </div>


                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                    <TextField
                    id="agentCode"
                    onChange={(e) => setAgentCode(e.target.value)}
                    value = {agentCode}
                    placeholder="Enter Your Outlet Agent Code"
                    style={{width:'100%'}}
                  />


                   </div>

                 

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                    <TextField
                    id="subscriberID"
                    onChange={(e) => setSubscriberID(e.target.value)}
                    value = {subscriberID}
                    placeholder="Enter Your Outlet ID"
                    style={{width:'100%'}}
                    disabled

                  />

                  </div>

                


              <Button 
              onClick={handleUpdateOutlet} 
              style={{width:'96%', backgroundColor:'rgb(15, 31, 175)', paddingTop:20, paddingBottom:20}}>{isloading ? <Spinner/>: 'Update Outlet'}
              </Button>

            </div>
            <div className='item'>
            {/* <img
                src = {outletData.userImage}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%', marginTop:20}}
                   
            />  */}
              
                {/* <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Customer ID:</span>
                    <span className='itemValue'>{outletData.userCustomerId}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Firstname:</span>
                    <span className='itemValue'>{outletData.userFirstname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Lastname:</span>
                    <span className='itemValue'>{outletData.userLastname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{outletData.userGender}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Age Range:</span>
                    <span className='itemValue'>
                      {
                      outletData.ageRange === "firstagerange"
                      ?
                      "18 to 29"
                      :
                      outletData.ageRange === "secondagerange"
                      ?
                      "30 to 39"
                      :
                      outletData.ageRange === "thirdagerange"
                      ?
                      "40 to 59"
                      :
                      "60 and Above"
                   
                      }
                    </span>
                  </div>
                </div>


                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='itemValue'>{outletData.userTelephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{outletData.userEmail}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Telephone:</span>
                    <span className='itemValue'>{outletData.telephone}</span>
                  </div>
                  
                 
                </div> */}


            </div>
          </div>
        
        </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Photos</h2>
            <div style={{display:'flex', flexDirection:'row', gap:30, flexWrap:'wrap'}}>

            {/* <img
                src = {outletData.files.map(item => item)}
                alt="avatar"
                style={{width:'200px', height:'200px'}}
                   
            />  */}

          
             {
              photos.map(item =>(
                <div key={item}  style={{position:'relative'}}>
                  {/* <button onClick={() => handleModal(item)} style={{position:'relative'}}> */}

                  {/* <button style={{position:'relative'}}> */}

                  <div onClick={() => deleteUrl(item)}  style={{display:'flex', position:'absolute', top:10, right:10, width:30, height:30, justifyContent:'center', borderRadius:'50%', backgroundColor:'#666', cursor:'pointer'}}><h4 style={{alignSelf:'center', color:'#999'}}>X</h4></div>

                    <img
                    
                      key={item}
                      src = {item}
                      alt="avatar"
                      style={{width:'200px', height:'200px', borderRadius:10}}
                    
                    /> 

                  {/* </button> */}
                  
                </div>
              ))
             } 
          
              

            </div>
          </div>
          {/* <div>
            <Chart 
              aspect={3/1}
              title = "Customer purchase last 6 months"
            />
          </div> */}
        </div>


        <div className="bottom">
       
        </div>


      </div>
    </div>
  )
}

export default Edit